// signup
export const ACTIVATION_BEGIN = 'ACTIVATION_BEGIN';
export const ACTIVATION_CLEAR = 'ACTIVATION_CLEAR';
export const ACTIVATION_FAILURE = 'ACTIVATION_FAILURE';
export const ACTIVATION_SUCCESS = 'ACTIVATION_SUCCESS';
export const REGISTRATION_BEGIN = 'REGISTRATION_BEGIN';
export const REGISTRATION_CLEAR = 'REGISTRATION_CLEAR';
export const REGISTRATION_FAILURE = 'REGISTRATION_FAILURE';
export const REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS';

// auth
export const LOGIN_BEGIN = 'LOGIN_BEGIN';
export const LOGIN_CLEAR = 'LOGIN_CLEAR';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const SET_TOKEN = 'SET_TOKEN';
export const REMOVE_TOKEN = 'REMOVE_TOKEN';
export const SET_USER = 'SET_USER';

// password
export const PASSWORD_EMAIL_BEGIN = 'PASSWORD_EMAIL_BEGIN';
export const PASSWORD_EMAIL_CLEAR = 'PASSWORD_EMAIL_CLEAR';
export const PASSWORD_EMAIL_FAILURE = 'PASSWORD_EMAIL_FAILURE';
export const PASSWORD_EMAIL_SUCCESS = 'PASSWORD_EMAIL_SUCCESS';
export const PASSWORD_RESET_BEGIN = 'PASSWORD_RESET_BEGIN';
export const PASSWORD_RESET_CLEAR = 'PASSWORD_RESET_CLEAR';
export const PASSWORD_RESET_FAILURE = 'PASSWORD_RESET_FAILURE';
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';

//chat
export const SET_ROOMS = 'SET_ROOMS';
export const CHANGE_ROOM = 'CHANGE_ROOM';
export const SET_MESSAGES = 'SET_MESSAGES';
export const PUSH_MESSAGES = 'PUSH_MESSAGES';
export const PUSH_MESSAGE = 'PUSH_MESSAGE';
export const PUSH_LAST_MESSAGE = 'PUSH_LAST_MESSAGE';
export const UPDATE_MESSAGE_AFTER_SAVE = 'UPDATE_MESSAGE_AFTER_SAVE';
export const UPDATE_MESSAGE_WS = 'UPDATE_MESSAGE_WS';
export const SET_MESSAGE_FAILURE = 'SET_MESSAGE_FAILURE';
export const INC_PAGE = 'INC_PAGE';
export const SET_MESSAGES_LOADED = 'SET_MESSAGES_LOADED';
export const CHANGE_MESSAGE = 'CHANGE_MESSAGE';
export const DELETE_MESSAGE = 'DELETE_MESSAGE';
export const ADD_REACTION = 'ADD_REACTION';
export const REMOVE_REACTION = 'REMOVE_REACTION';
export const SET_FILE_URL = 'SET_FILE_URL';
export const PUSH_FILE_TO_MESSAGE = 'PUSH_FILE_TO_MESSAGE';
export const DELETE_FILE = 'DELETE_FILE';